import { DEV } from "solid-js"
import { freeze } from "../util/Object"
import { DIRECTION_DXDY_NORTH_EAST, DIRECTION_DXDY_NORTH_WEST, DIRECTION_DXDY_SOUTH_EAST, DIRECTION_DXDY_SOUTH_WEST } from "./diagonalDirections"
import { DIRECTION_DXDY_EAST, DIRECTION_DXDY_NORTH, DIRECTION_DXDY_SOUTH, DIRECTION_DXDY_WEST } from "./dijkstraDirections"
import { type DirectionDxDy } from "./DirectionDxDy.type"

const eightDirections: ReadonlyArray<DirectionDxDy> = [
  DIRECTION_DXDY_SOUTH,
  DIRECTION_DXDY_SOUTH_EAST,
  DIRECTION_DXDY_EAST,
  DIRECTION_DXDY_NORTH_EAST,
  DIRECTION_DXDY_NORTH,
  DIRECTION_DXDY_NORTH_WEST,
  DIRECTION_DXDY_WEST,
  DIRECTION_DXDY_SOUTH_WEST,
] as const

if (DEV) {
  freeze(eightDirections)
}

export default eightDirections